class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.summaryToggles = document.querySelectorAll('.summary---modal');
    this.closes = document.querySelectorAll('.summary---modal--close');
    this.searchButtons = document.querySelectorAll('#search-button, .search-button');

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );

    if (this.summaryToggle) {
      this.summaryToggle.addEventListener(
        'click',
        this.onSummaryClick.bind(this)
      );

     this.summaryToggle.setAttribute('role', 'button');
    }

    this.searchButtons.forEach(cls => {
      cls.addEventListener(
        'click',
        this.openCustom.bind(this)
      );
    });
    

    this.summaryToggles.forEach(summaryToggle => {
      summaryToggle.addEventListener(
        'click',
        this.onSummaryClickCustom.bind(this)
      );
    });
    
    this.querySelector('button[type="button"]').addEventListener(
      'click',
      this.close.bind(this)
    );


    this.closes.forEach(cls => {
      cls.addEventListener(
        'click',
        this.closeCustom.bind(this)
      );
    });


    // Add event listener to the document
    const self = this
    document.querySelector('.search---block').addEventListener('click', function(event) {
      const target = event.target;
      // Check if the clicked element or its ancestors match the desired condition
      if (!target.closest('.details.custom-----search') && document.querySelector('.custom-----search').hasAttribute('open')) {
        self.closeCustom(true)
      }
    });

  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  openCustom(event) {
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');
    document.querySelector('.search---block').setAttribute('open', true);
    
    this.searchInput.forEach(function(input) {
      input.focus();
    });

    this.lazyLoadFunc();
  }

  lazyLoadFunc() {
	const images = document.querySelectorAll('[open="true"] .searchImage .lateLoading');
    if(images.length){
      images.forEach(img => {
          if (img?.dataset?.src && !img.classList.contains('lazyloaded')) {
              img.removeAttribute('loading')
              img.classList.add('lazyloaded')
              img.src = img.dataset.src;
          }
  
          if (!img?.dataset?.src && !img.classList.contains('lazyloaded')) {
              img.removeAttribute('loading')
              img.classList.add('lazyloaded')
          }
      });
    }
    
}

  onSummaryClickCustom(event) {
    event.preventDefault();
    
    // Find the closest parent div element with the data-target attribute
    const targetDiv = event.target.closest('div[data-target]');
    
    if (targetDiv) {
      const target = targetDiv.getAttribute('data-target');
      const elm = document.querySelector(target);

      if (elm.closest('.details').hasAttribute('open')) {
        this.close();
      } else {
        const detailsElement = elm.closest('.details')
        document.querySelector('.custom-----search').setAttribute('open', true);
        // document.querySelector('.custom-----search').setAttribute('data--open', true);
        elm.classList.add('overlay-modal---visiblity');

        if (detailsElement) {
          detailsElement.setAttribute('open', true);
          document.body.addEventListener('click', this.onBodyClickEvent);
          document.body.classList.add('overflow-hidden');

          
          document.querySelector('.search---block').setAttribute('open', true);
      
          trapFocus(
            this.detailsContainer.querySelector('[tabindex="-1"]'),
            this.detailsContainer.querySelector('input:not([type="hidden"])')
          );
        }
      }

      document.querySelectorAll('.search---block [name="q"]').forEach(tt => {
        tt.focus();
      });

      this.lazyLoadFunc();
      
    }
  }

  onSummaryClick(event) {
    event.preventDefault();
    if(document.querySelector('.filter-collections')){
      let top = '5px';
      if(document.querySelector('.filter-collections').classList.contains('sticky')){
        top = '0px';
      }
      document.querySelector('.filter-collections').classList.remove('sticky', 'extra-top-sticky')
     
      event.target.closest('details').hasAttribute('open')
        ? this.close()
        : this.open(event);
        
      setTimeout(() => {
        document.querySelector('.filter-collections').classList.remove('sticky', 'extra-top-sticky')
      }, 1000);

      if((document.documentElement.scrollTop || document.body.scrollTop) === 0){
        top = '5px';
      }

      document.querySelector('.search-modal .search-modal__content').style.top = top;
      

    }
    else {
      if((document.documentElement.scrollTop || document.body.scrollTop) !== 0){
        document.querySelector('.search-modal .search-modal__content').style.top = 0;
      }
      else {
        document.querySelector('.search-modal .search-modal__content').style.top = '-40px';
      }

      event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);

      
    }

    
    /*
    

    setTimeout(() => {
    console.log(document.querySelector('.filter-collections'));

    }, 1000);

    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);
    */
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }
  
  
  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    if (document.querySelector('sticky-header').querySelectorAll('.overlay-modal---show').length <= 0) {
      const overlay = document.createElement('div');
      overlay.className = 'overlay-modal---show';
      document.querySelector('sticky-header').appendChild(overlay);
    }

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    if (this.detailsContainer.closest('details-modal').classList.contains('header__search')) {
      // return;
    }
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');

    if (document.querySelector('sticky-header').querySelectorAll('.overlay-modal---show').length > 0) {
      document.querySelector('sticky-header').querySelector('.overlay-modal---show').remove();
    }

  }

  closeCustom(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.querySelectorAll('.details').forEach(t => t.removeAttribute('open'))
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');

    document.querySelector('.search---block').removeAttribute('open');

    if (document.querySelector('sticky-header').length > 0) {
      document.querySelector('sticky-header').style.display = 'block';
    }
  }
}


customElements.define('details-modal', DetailsModal);
